function MaterialRequestIcon(props) {
  const { isActive } = props
  return (
    <svg
      width="14"
      height="10"
      viewBox="0 0 14 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.666666 1.33333H2.66667L5 7M5 7H10.8333L13.3333 2.33333M5 7L3.66667 9H12.3333M6 3H10M8 1V5"
        stroke={!isActive ? '#828282' : '#FFFFFF'}
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default MaterialRequestIcon
